/**
 * @file        src/api/quotes.js
 * @description Group-booking ("Flight Request") quote submission. The modal used to
 *              flip straight to its success screen without sending anything — the
 *              customer was promised a specialist within 12–24 hours and nothing
 *              ever reached the ops team. This posts to the backend, which emails
 *              the brand's support inbox.
 * @author      Kinetika Labs
 * @created     2026-08-11
 * @changelog
 *   - 2026-08-11 Claude — Initial (group quote request → ops email).
 */
import { post } from './client.js';

/**
 * POST /quote-request — the backend requires name, mobile and email and mails the
 * brand's support address.
 *
 * @param {{name:string, mobile:string, email:string, flightDetails?:string,
 *          paxInfo?:string, budget?:string, remarks?:string}} payload
 *   `mobile`, not `phone` — that is the key the server validates on.
 */
export async function requestFlightQuote(payload) {
  return post('/quote-request', payload);
}
